export enum AppRoutes {
  ExperimentOverview = '/',
  Documentation = '/documentation',
  Tutorials = '/tutorials',
  Profiling = '/profiling',
  Experiment = '/experiment/:id/*',
  ExperimentDataOverview = 'data-overview',
  ExperimentRepertoireAnalysis = 'repertoire-analysis',
  ExperimentTsneUmap = 'tsne-umap-viewer',
  ExperimentClonotypeNetworkMap = 'clonotype-network-map',
  ExperimentAntibodyAnalysis = 'antibody-analysis',
  ExperimentExportSummary = 'export-summary',
}

export function makeExperimentRoute(experimentId: string, route: string) {
  return AppRoutes.Experiment.replace(':id', experimentId).replace('*', route);
}
